import React from 'react';
import { checklistToneMap } from '../lib/recoveryRolloutFormatters';

const ChecklistStatusBadge = ({ status = 'WARNING' }) => {
  const key = String(status || 'WARNING').toUpperCase();
  const tone = checklistToneMap[key] || checklistToneMap.WARNING;
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-semibold ${tone}`}>
      {key}
    </span>
  );
};

export default ChecklistStatusBadge;
